import psHttp from '@patsnap/common-ps-http';
import { coreSearchApiUrlPrefix } from '../../config/constants';

export function translateByMachine ({ from, text, to, patentId, field, type }) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/translate/text`,
        method: 'POST',
        data: { from, text, to, patentId, field, type },
        transformCode: true,
        cache: true,
        uuid: `_translateByGoogleBaidu_${from}_${text}_${to}_${type}`,
    });
}

export function translateByPatsnapApi (patentId, data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/translate/patent`,
        method: 'POST',
        data,
        transformCode: true,
        cache: true,
        uuid: `transPatsnap_${patentId}_${data.lang}_${data.field}_${data.compare_related_id}`,
    });
}
